<template>
  <article class="d-none d-sm-block">
    <div class="container">
      <div class="row mt-n5 mt-sm-n6">
        <div class="col-12 col-sm-10 col-lg-6 col-xl-5">
          <h3 class="headline-bg bg-white text-purple py-3 pb-lg-3 pt-lg-0 mb-sm-5 mb-lg-6">
            Schreiben Sie uns
          </h3>
        </div>
      </div>
    </div>
  </article>
  <div class="container" id="form-container">
    <div v-if="formSubmitted" class="row">
      <div class="col-10 pt-6 pb-2 mx-auto">
        <h3 class="h2 fw-normal text-white">
          Vielen Dank für Ihre Nachricht,<br>wir werden uns zeitnah zurückmelden.
        </h3>
      </div>
    </div>
    <div v-else class="row text-center">
      <h3 class="h2 fw-normal text-white d-block d-sm-none">
        Schreiben Sie uns!
      </h3>
      <form id="contact-form" ref="contactForm" action="/" class="mt-5 needs-validation" method="post" novalidate>
        <div class="col-12 contact my-3 text-center">
          <h3 class="lead fw-semibold text-white">Ihre Daten</h3>
        </div>
        <div class="row gx-3">
          <div class="col-12 contact col-md-6">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="name"
                     placeholder="Vorname, Name*" required type="text">
              <div class="invalid-feedback">
                Bitte geben Sie Ihren Namen an
              </div>
              <label class="" for="name">Vorname, Name*</label>
            </div>
          </div>
          <div class="col-5 col-md-2 order-4 order-md-2">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="plz"
                     placeholder="PLZ" type="text">
              <label class="" for="plz">PLZ</label>
            </div>
          </div>
          <div class="col-7 col-md-4 order-4 order-md-2">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="ort"
                     placeholder="Ort" type="text">
              <label class="" for="ort">Ort</label>
            </div>
          </div>

          <div class="col-12 contact col-md-6 order-2 rounded-0">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="email"
                     placeholder="E-Mail*" required type="email">
              <div class="invalid-feedback">
                Bitte geben Sie eine gültige E-Mail-Adresse an
              </div>
              <label class="" for="email">E-Mail*</label>
            </div>
          </div>
          <div class="col-12 contact col-md-6 order-5 order-md-4">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="company"
                     placeholder="Unternehmen" type="text">
              <label class="" for="company">Unternehmen</label>
            </div>
          </div>

          <div class="col-12 contact col-md-6 order-3 order-md-5">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="phone"
                     placeholder="Telefonnummer*" required type="tel">
              <div class="invalid-feedback">
                Bitte geben Sie Ihre Telefonnummer an
              </div>
              <label class="" for="phone">Telefonnummer*</label>
            </div>
          </div>
          <div class="col-12 contact col-md-6 order-5">
            <div class="form-floating mb-3">
              <input class="form-control rounded-0" name="job"
                     placeholder="Beruf / Stelle" type="text">
              <label class="" for="job">Beruf / Stelle</label>
            </div>
          </div>
        </div>
        <div class="col-12 contact my-4 text-center">
          <h3 class="lead fw-semibold text-white">Ihre Nachricht</h3>
        </div>
        <div class="form-floating">
          <textarea class="form-control rounded-0" name="message" placeholder="" required style="height: 140px"></textarea>
          <div class="invalid-feedback">
            Bitte hinterlassen Sie eine Nachricht
          </div>
        </div>
        <div class="row gx-4">
          <div class="col-12 col-md-6 contact text-center py-5 font-slab lead fw-bold text-white">
            <div id="drop-area" class="px-5 py-3">
              <span class="d-block d-sm-none">
                  <label class="custom-file-upload dzClickable" for="file-upload">
                      Dateien anhängen
                  </label>
                  <input id="file-upload" class="btn-link" type="file">
              </span>
              <span class="d-none d-sm-block ">
                  Anhänge hier ablegen<br>
                  <label class="custom-file-upload dzClickable" for="file-upload">
                      oder klicken
                  </label>
                  <input id="file-upload" class="btn-link" type="file">
              </span>
              <small>(max. 4 Dateien / 30mb)</small>
            </div>
          </div>

          <div id="dzPreviews" class="col-12 col-md-6 text-start py-2 py-md-5 fw-normal text-white">

          </div>

        </div>
        <div v-if="apiError!==''" class="col text-danger">
          {{ apiError }}
        </div>
        <div class="col-12 col-md-4 mx-auto contact my-4 text-center">
          <a href="#form-container" :disabled="workers>0"
                  class="btn btn-lg btn-primary text-white w-100"
                  @click="submitForm">Absenden
            <div v-if="workers>0" class="spinner-border spinner-border-sm"
                 role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </a>
        </div>
      </form>
    </div>
  </div>


  <div id="dzTemplate" class="file-upload-pdf d-none">
    <div class="type">
      <i class="fa-solid lead me-2"></i>
      <span class="name" data-dz-name></span> (<span class="name" data-dz-size></span>)
      <i class="ms-3 fa-solid fa-xmark text-danger lead" data-dz-remove></i>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import Dropzone from "dropzone";

// form handling variables
const workers = ref(0);
const formSubmitted = ref(false);
const apiError = ref('');

// form dom object
const contactForm = ref(null);

// regex for finding fa-class from filename
const iconClasses = {
  '\.pdf$': 'fa-file-pdf',
  '\.docx?$' : 'fa-file-word',
  '\.(zip|rar)$': 'fa-file-zipper',
  '\.(png|jpe?g|gif|webp|haic)$': 'fa-file-image',
  '\.(mp4|avi|mpe?g|mov)$': 'fa-file-video',
};

// method for setting fa-class
const setIconClass = file => {
  for( const [regEx, iconClass] of Object.entries(iconClasses)) {
    if((new RegExp(regEx, 'i')).test(file.name)){
      file.previewElement.children[0].classList.add(iconClass);
      return;
    }
  }
  file.previewElement.children[0].classList.add('fa-file');
}

// method for form submission
const submitForm = () => {
  // form validation
  if (contactForm.value.checkValidity()) {
    workers.value++;

    // append files to form data
    let formData = new FormData(contactForm.value);
    dropzone.getQueuedFiles().forEach(file => {
      formData.append('files[]', file);
    });

    // reset api error
    apiError.value = '';

    // submit form
    axios.post('/kontakt', formData,
        {
          headers: {"Content-Type": "multipart/form-data"}
        })
        .then(result => {
          formSubmitted.value = true;
        })
        .catch(error => {
          apiError.value = 'Unbekannter API-Fehler';
          if(error.response) {
            apiError.value = 'API-Fehler: ' + error.response.data.message;
          }
        })
        .finally(() => {
          workers.value--;
        });
  }
  contactForm.value.classList.add('was-validated');
}

// global dropzone variable
let dropzone;

// lifecycle hook
onMounted(() => {

  const dropzoneOptions = {
    url: '/',
    clickable: '.dzClickable',
    autoProcessQueue: false,
    uploadMultiple: true,
    parallelUploads: 4,
    maxFiles: 4,
    maxFilesize: 30,
    maxTotalFilesize: 30,
    filesizeBase: 1024,
    dictMaxFilesExceeded: "Maximale Anzahl Dateien erreicht. Datei nicht hinzugefügt.",
    dictMaxFileSizeExceeded: "Maximale Upload-Größe erreicht. Datei nicht hinzugefügt.",
    previewsContainer: '#dzPreviews',
    createImageThumbnails: false,
    previewTemplate: document.querySelector('#dzTemplate').innerHTML,

    // validation of total filesize
    accept: function (file, done) {
      if (this.totalFilesize >= this.maxTotalFilesizeMiB) {
        this.removeFile(file);
        this._errorProcessing([file], this.options.dictMaxFileSizeExceeded, null);
      } else {
        done();
      }
    },

    // calculation of total filesize and setting of fa-class
    init: function () {
      this.totalFilesize = 0;
      this.maxTotalFilesizeMiB = this.options.maxTotalFilesize * this.options.filesizeBase * this.options.filesizeBase;

      this.on('addedfile', file => {
        this.totalFilesize += file.size;
        setIconClass(file);
      });

      this.on('removedfile', file => {
        this.totalFilesize -= file.size;
      });

      this.on('maxfilesexceeded', file => {
        this.removeFile(file);
      });

      // error handling
      this.on('error', (file, message) => {
        alert(message);
      });
    }
  }

  dropzone = new Dropzone('#drop-area', dropzoneOptions);
});

</script>

<style scoped>

</style>